module.exports = __webpack_public_path__ + "img/save.9c3127ed.svg";